import React from 'react'
import "./JobPostings.css";
import * as FeatherIcon from 'react-feather';



export default function JobPostings({ active_tab_key }) {
  return (
    <div>
      <div className='container'>
        <div className='early_signal_wrapper mt-4'>
          <div className="head_top">
            <h5 className="main_head">Early Signals</h5>
          </div>
          <div className="table_block">

<div className="row">
  <div className="col-md-6"> 
  <div className="positive_block">
    <div className='early_signal_block'>
      <img src="/img/early_signal.png" alt="icon" className='icon'/>
      <p className='discover_text'>Discover exciting career opportunities at Boeing.</p>
    </div>
 
   <ul className="list_vertical_tab">
      <h5 className="head">Boeing is heavily investing in:</h5>
      <li className="list_tabs"><i className="fa fa-circle" aria-hidden="true"></i>Modernizing its software and systems development capabilities.</li>
      <li className="list_tabs"><i className="fa fa-circle" aria-hidden="true"></i>Strengthening its defense and aerospace maintenance programs.</li>
      <li className="list_tabs"><i className="fa fa-circle" aria-hidden="true"></i>Expanding its global support operations and supply chain.</li>
      <li className="list_tabs"><i className="fa fa-circle" aria-hidden="true"></i>Leveraging emerging technologies like HPC, cybersecurity, and advanced.</li>
   </ul>
</div>
  </div>

  <div className="col-md-6">
    <div className="table-responsive ml-4">
      <div className='chart_block'>
        <img src="/img/chart_dummy.png" className='chart' alt="chart"/>
      </div>
  
      </div>
  </div>

</div>

<div className='row'>
<div className="growth_opp_block mt-3">
                <div className="growth_table_block">
                  <div className="table-responsive">
                    <table className="growth_table bordered">
                      <thead className="growth_thead">
                        <tr className="tr_growth">
                         
                          <th className="growth_th cursorP" >
                          <FeatherIcon.Calendar className='icons_table mr-1' /> Posting Date 
                          </th>
                          <th className="growth_th cursorP">
                          <FeatherIcon.Briefcase className='icons_table mr-1' /> Job Title
                          </th>
                          <th className="growth_th cursorP">
                          <FeatherIcon.Settings className='icons_table mr-1' /> Job Function 
                          </th>
                       
                          <th className="growth_th align-right cursorP">
                          <FeatherIcon.Users className='icons_table mr-1' /> No. Of vacancies                         
                          </th>
                        
                        </tr>
                      </thead>
                      <tbody className="growth_tbody">
                    
                            <tr className="">
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Dec 2024
                                </span>
                              </td>
                                   <td className="growth_td">
                                <span className="bookmar_icon">
                                Senior Compensation Specialist
                                </span>
                              </td>
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Supervising and managing a department team
                                </span>
                              </td>
                              <td className="growth_td align-right">
                                <span className="bookmar_icon">
                                   10
                                </span>
                              </td>
                            </tr>  

                                <tr className="">
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Dec 2024
                                </span>
                              </td>
                                   <td className="growth_td">
                                <span className="bookmar_icon">
                                Senior Compensation Specialist
                                </span>
                              </td>
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Supervising and managing a department team
                                </span>
                              </td>
                              <td className="growth_td align-right">
                                <span className="bookmar_icon">
                                   10
                                </span>
                              </td>
                            </tr>  

                               <tr className="">
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Dec 2024
                                </span>
                              </td>
                                   <td className="growth_td">
                                <span className="bookmar_icon">
                                Senior Compensation Specialist
                                </span>
                              </td>
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Supervising and managing a department team
                                </span>
                              </td>
                              <td className="growth_td align-right">
                                <span className="bookmar_icon">
                                   10
                                </span>
                              </td>
                            </tr> 

                               <tr className="">
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Dec 2024
                                </span>
                              </td>
                                   <td className="growth_td">
                                <span className="bookmar_icon">
                                Senior Compensation Specialist
                                </span>
                              </td>
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Supervising and managing a department team
                                </span>
                              </td>
                              <td className="growth_td align-right">
                                <span className="bookmar_icon">
                                   10
                                </span>
                              </td>
                            </tr> 

                               <tr className="">
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Dec 2024
                                </span>
                              </td>
                                   <td className="growth_td">
                                <span className="bookmar_icon">
                                Senior Compensation Specialist
                                </span>
                              </td>
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Supervising and managing a department team
                                </span>
                              </td>
                              <td className="growth_td align-right">
                                <span className="bookmar_icon">
                                   10
                                </span>
                              </td>
                            </tr> 

                               <tr className="">
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Dec 2024
                                </span>
                              </td>
                                   <td className="growth_td">
                                <span className="bookmar_icon">
                                Senior Compensation Specialist
                                </span>
                              </td>
                              <td className="growth_td">
                                <span className="bookmar_icon">
                                Supervising and managing a department team
                                </span>
                              </td>
                              <td className="growth_td align-right">
                                <span className="bookmar_icon">
                                   10
                                </span>
                              </td>
                            </tr>                
                      </tbody>
                    </table>
                  </div>              
                </div>
              </div>
</div>





{/* <div className="table-responsive">
  <RevenueAnalysisTable data={revenueByGeographyTableData} />
</div> */}

</div>
        </div>
      </div>
    </div>
  )
}
